import { makeStyles } from "@material-ui/core";

export const disabledContractStyle = makeStyles(theme => ({
    wrapper: {
        padding: '1em'
    },


}));